import Vue from 'vue'
import VueRouter from 'vue-router'
import DashboardLayout from '@/layout/DashboardLayout'
import AuthLayout from '@/layout/AuthLayout'
import store from "./store";

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  linkExactActiveClass: 'active',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      redirect: 'login',
      component: AuthLayout,
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import('./views/Login.vue')
        }
      ]
    },
    {
      path: '/',
      redirect: 'dashboard',
      component: DashboardLayout,
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('./views/Dashboard.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/profile',
          name: 'Profile',
          component: () => import('./views/profile.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/upload',
          name: 'Upload',
          component: () => import('./views/Upload.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/role/create',
          name: 'Add Role',
          component: () => import('./views/roles/Add'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/role/:id',
          name: 'Edit Role',
          component: () => import('./views/roles/Edit'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/roles',
          name: 'Roles',
          component: () => import('./views/roles'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/users',
          name: 'Users',
          component: () => import('./views/users'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/user/create',
          name: 'Add User',
          component: () => import('./views/users/Add'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/user/:id',
          name: 'Edit User',
          component: () => import('./views/users/Edit'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "news-category",
          name: "News Category",
          component: () => import("./views/news-category"),
          meta: {
            requiresAuth: true
          }
        },
        // {
        //   path: "news-category/create",
        //   name: "Create News Category",
        //   component: () => import("./views/news-category/Add"),
        //   meta: {
        //     requiresAuth: true
        //   }
        // },
        {
          path: "news-category/:id",
          name: "Edit News Category",
          component: () => import("./views/news-category/Add"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "news-feed",
          name: "NewsFeed",
          component: () => import("./views/news-feed"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "news-feed/:id",
          name: "Edit NewsFeed",
          component: () => import("./views/news-feed/Add"),
          meta: {
            requiresAuth: true
          }
        },
        // {
        //   path: "news-feed/create",
        //   name: "Create NewsFeed",
        //   component: () => import("./views/news-feed/Add"),
        //   meta: {
        //     requiresAuth: true
        //   }
        // },
        {
          path: "manufacturer",
          name: "Manufacturer",
          component: () => import("./views/manufacturer"),
          meta: {
            requiresAuth: true
          }
        },
        // {
        //   path: "manufacturer/create",
        //   name: "Create Manufacturer",
        //   component: () => import("./views/manufacturer/Add"),
        //   meta: {
        //     requiresAuth: true
        //   }
        // },
        {
          path: "manufacturer/:id",
          name: "Edit Manufacturer",
          component: () => import("./views/manufacturer/Add"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "product-parameter",
          name: "Parameter",
          component: () => import("./views/product-parameter"),
          meta: {
            requiresAuth: true
          }
        },
        // {
        //   path: "product-parameter/create",
        //   name: "Create Parameter",
        //   component: () => import("./views/product-parameter/Add"),
        //   meta: {
        //     requiresAuth: true
        //   }
        // },
        {
          path: "product-parameter/:id",
          name: "Edit Parameter",
          component: () => import("./views/product-parameter/Add"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "products",
          name: "Products",
          component: () => import("./views/products"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "products/create",
          name: "Create Products",
          component: () => import("./views/products/Add"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "products/edit/:id",
          name: "Edit Products",
          component: () => import("./views/products/Edit"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/journal-club',
          name: 'Journal Club',
          component: () => import('./views/journalClub'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/journal-club/:id',
          name: 'Edit Journal Club',
          component: () => import('./views/journalClub/Add'),
          meta: {
            requiresAuth: true
          }
        },
        // {
        //   path: '/contact-us',
        //   name: 'Edit Contact Us',
        //   component: () => import('./views/contactUs'),
        //   meta: {
        //     requiresAuth: true
        //   }
        // },
        {
          path: "community",
          name: "Community",
          component: () => import("./views/community"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/clinic',
          name: 'Clinic',
          component: () => import('./views/clinic'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/clinic/:id',
          name: 'Edit Clinic',
          component: () => import('./views/clinic/Add'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/lp-profile',
          name: 'LP Profile',
          component: () => import('./views/lpProfile'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/lp-profile/:id',
          name: 'Edit LP Profile',
          component: () => import('./views/lpProfile/Add'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/library',
          name: 'Library',
          component: () => import('./views/library'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/library/:id',
          name: 'Edit Library',
          component: () => import('./views/library/Add'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/faq/:id',
          name: 'Edit FAQ',
          component: () => import('./views/faq/Add'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/faq',
          name: 'FAQ',
          component: () => import('./views/faq'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/guide-card/:id',
          name: 'Edit Guide Card',
          component: () => import('./views/home/guideCard/Add'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/guide-card',
          name: 'Guide Card',
          component: () => import('./views/home/guideCard'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/testimonials/:id',
          name: 'Edit Testimonials',
          component: () => import('./views/home/testimonials/Add'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/testimonials',
          name: 'Testimonials',
          component: () => import('./views/home/testimonials'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/useful-links/:id',
          name: 'Edit Useful Links',
          component: () => import('./views/home/usefuleLink/Add'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/useful-links',
          name: 'Useful Links',
          component: () => import('./views/home/usefuleLink'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/events/:id',
          name: 'Edit Events',
          component: () => import('./views/event/Add'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/events',
          name: 'Events',
          component: () => import('./views/event'),
          meta: {
            requiresAuth: true
          }
        },
        // {
        //   path: "community/create",
        //   name: "Create Community",
        //   component: () => import("./views/community/Add"),
        //   meta: {
        //     requiresAuth: true
        //   }
        // },
        {
          path: "community/:id",
          name: "Edit Community",
          component: () => import("./views/community/Add"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "requests",
          name: "Requests",
          component: () => import("./views/community/UserRequestList"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "notifications",
          name: "Activity Logs",
          component: () => import("./views/notifications"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "profile",
          name: "Profile",
          component: () => import("./views/profile"),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
  ]
})

router.beforeEach((to, from, next) => {
  const user = store.state.user;
  if (user) {
    if (to.name == "login" && user.isUserLoggedIn) {
      next({ path: '/dashboard' });
    } else if (to.name !== "login" && !user.isUserLoggedIn) {
      next({ path: '/login' });
    }
    else {
      next();
    }
  } else {
    next();
  }

});

export default router